import React from "react";

import { graphql } from "gatsby";
import { Helmet } from "react-helmet";

const normalizeWhiteSpace = (str: string) => str.replace(/\s+/g, " ");

export interface MetaProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  canonical?: string;
  noindex?: boolean;
  linkedData?: string;
}

const Meta: React.FC<MetaProps> = ({
  title = "Uizard",
  description = "The easy-to-use design tool",
  image = "https://uizard.io/opengraph-2021-04-26-10-35.png",
  url = "",
  canonical = "",
  noindex = false,
  linkedData,
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />

    <meta property="og:url" content={`https://uizard.io${url}`} />
    <meta property="og:type" content="article" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />

    <link
      rel="canonical"
      href={
        canonical ? `https://uizard.io${canonical}` : `https://uizard.io${url}`
      }
    />

    {noindex === true ? <meta name="robots" content="noindex" /> : ""}
    {linkedData ? (
      <script type="application/ld+json">
        {normalizeWhiteSpace(linkedData)}
      </script>
    ) : (
      ""
    )}
  </Helmet>
);

export interface MetaSanityCompatibleProps {
  slug: Queries.SanityBlockPage["slug"];
  meta: Queries.SanityBlockPage["meta"];
}

export const MetaSanityCompatible: React.FC<MetaSanityCompatibleProps> = ({
  slug,
  meta,
}) => (
  <Meta
    title={meta?.title ?? undefined}
    description={meta?.description ?? undefined}
    image={
      meta?.image?.asset?.localFile?.childImageSharp?.gatsbyImageData?.images
        ?.fallback?.src ?? undefined
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    url={slug!}
    canonical={meta?.canonical ?? undefined}
    noindex={meta?.noindex ?? undefined}
    linkedData={meta?.linkedData ?? undefined}
  />
);

export const query = graphql`
  fragment Meta on SanityMeta {
    _key
    _type
    title
    description
    image {
      asset {
        localFile {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED)
          }
        }
      }
    }
    canonical
    noindex
    linkedData
  }
`;

export default Meta;
